/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useToast } from "../../context/toast-context";
import useAPIHandler from "../../hook/use-api-handler";
import { logger } from "../../utils/logger";
import { calculateTotalDeduction, getTotalearn } from "./utils";

const Payrollservice = () => {
  const { fetchData } = useAPIHandler();
  const { showToastMessage } = useToast();

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setSearchinfo({ month: null, year: null });
  };

  const [salarylistdata, setSalarylistdata] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState(""); // Ensure it's a string
  const [serchinfo, setSearchinfo] = useState({ month: null, year: null });

  const [count, setCout] = useState(0);
  const [useInfo, setUserinfo] = useState({});

  const [openEmployee, setOpenEmployee] = useState(false);
  const handleClickOpenEmployee = (row) => {
    setUserinfo({ ...row, no_work_for_full_month: row?.payable_days === 0 });
    setOpenEmployee(true);
  };
  const handleCloseEmployee = () => setOpenEmployee(false);

  const GetSalary = async () => {
    if (!serchinfo?.month || !serchinfo?.year) {
      return;
    }
    const payload = {
      data: { month: serchinfo?.month, year: serchinfo?.year },
      url: "salary",
      method: "POST",
    };
    fetchData(payload)
      .then((res) => {
        if (res?.data?.count > 0) {
          getList();
        }
      })
      .catch((e) => {
        showToastMessage({ message: "Attendance not approved for this month", color: "danger" });
        logger.log(e);
      });
  };

  useEffect(() => {
    if (count === 1) {
      getList();
    }
  }, [searchQuery, rowsPerPage, currentPage, serchinfo]);

  const getList = async () => {
    setOpen(false);
    const payload = {
      url: `salary?month=${serchinfo?.month ?? ""}&year=${serchinfo?.year ?? ""}&search=${searchQuery}&pageLimit=${rowsPerPage}&page=${currentPage + 1}`,
      method: "GET",
    };

    fetchData(payload)
      .then((res) => {
        if (res) {
          const data = res?.data?.data || [];
          setSalarylistdata(data);
          
          if (data.length > 0) {
            showToastMessage({ message: "Data fetched successfully", color: "success" });
          }

          const totalPageCount = res?.data?.metadata?.totalPages || 0;
          setTotalPages(totalPageCount);

          if (totalPageCount > 0) {
            setCout(1);
          } else if (totalPageCount === 0 && !searchQuery) {
            GetSalary();
          }
        }
      })
      .catch((e) => {
        logger.log(e);
      });
  };

  const handleNextPage = () => {
    if (totalPages) {
      setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages - 1));
    }
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value.target.value));
    setCurrentPage(0);
    getList();
  };

  const UpdatePaySlip = async (data) => {
    const payload = {
      data: {
        ot_hour: Number(data?.ot_hour) || null,
        tds: Number(data?.tds) || null,
        bonus_amount: Number(data?.bonus_amount) || null,
        incentive_amount: Number(data?.incentive_amount) || null,
        advance_amount: Number(data?.advance_amount) || null,
        loan_advance: Number(data?.loan_advance) || null,
        canteen: Number(data?.canteen) || null,
        epf_arrear: Number(data?.epf_arrear) || null,
        esic_arrear: Number(data?.esic_arrear) || null,
        gross_arrear: Number(data?.gross_arrear) || null,
        any_other_amt: Number(data?.any_other_amt) || null,
        any_other_deduction: Number(data?.any_other_deduction) || null,
        remarks: data?.remarks,
        no_work_for_full_month: data?.no_work_for_full_month,
        pTaxAmount:Number(data?.pTaxAmount) || null,
        earning_salary : getTotalearn(data)  || null,
        total_deduction: calculateTotalDeduction(data) || null,
        payable_salary: getTotalearn(data) - calculateTotalDeduction(data) || null,
      },
      url: `salary/${data?.salary_id}`,
      method: "PUT",
    };

    fetchData(payload)
      .then((res) => {
        if (res) {
          handleCloseEmployee();
          getList();
        }
      })
      .catch((e) => {
        logger.log(e);
      });
  };

  const ApprovedSalary = async () => {
    const payload = {
      data: { month: serchinfo?.month, year: serchinfo?.year },
      url: "salary/approve",
      method: "POST",
    };

    fetchData(payload)
      .then((res) => {
        if (res) {
          showToastMessage({ message: "Payroll Generated successfully!", color: "success" });
          getList();
        }
      })
      .catch((e) => {
        logger.log(e);
      });
  };

  const DeleteSalary = async () => {
    const payload = {
      url: `salary?month=${serchinfo?.month}&year=${serchinfo?.year}`,
      method: "DELETE",
    };

    fetchData(payload)
      .then((res) => {
        if (res) {
          setCout(0);
          setSalarylistdata([]);
          setTotalPages(0);
          showToastMessage({ message: "Payroll Deleted successfully!", color: "danger" });
        }
      })
      .catch((e) => {
        logger.log(e);
      });
  };

  return {
    open,
    setOpen,
    handleClickOpen,
    handleClose,
    openEmployee,
    handleClickOpenEmployee,
    handleCloseEmployee,
    salarylistdata,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    setUserinfo,
    useInfo,
    serchinfo,
    setSearchinfo,
    UpdatePaySlip,
    ApprovedSalary,
    DeleteSalary,
    getList,
  };
};

export default Payrollservice;
